import { filterByName } from 'dashboard/helper/searchHelper';

// Enabled bases first, then disabled ones; alphabetical inside each group,
// ignoring case and accents.
export const sortPublicKnowledgeBases = (bases, enabledIds, locale) => {
  const enabled = new Set(enabledIds);

  return [...bases].sort((a, b) => {
    const aEnabled = enabled.has(a.id);
    const bEnabled = enabled.has(b.id);
    if (aEnabled !== bEnabled) return aEnabled ? -1 : 1;

    return a.name.localeCompare(b.name, locale, { sensitivity: 'base' });
  });
};

export const filterPublicKnowledgeBasesByName = filterByName;
